import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import { withRouter, Link } from 'react-router-dom';
import moment from 'moment';
import lo from 'lodash';

import {
  TxtConfirmDeleteDailyReport,
  TxtSuccessDeleteDailyReport
} from 'fixtures/texts';
import { DAILY_REPORT } from 'fixtures/api';
import { Label } from 'atoms/Texts';
import { FormSelect, FormMultiSelect } from 'atoms/Inputs';
import { ButtonReg } from 'atoms/Buttons';
import IconPng from 'atoms/IconPng';
import {
  statusBtnFormatter,
  actionFormatter,
  selectionFormatter
} from 'molecules/TableFormatters';
import DataTables from 'organisms/DataTable';
import ConfirmModal from 'organisms/ConfirmModal';
import ModalPage from 'templates/ModalPage';

import { deleteData } from 'services/cmsService';
import { setLocalSettingsTableData } from 'Redux/actions/SettingsTableActions';
import { getAllDailyReports } from 'Redux/actions/DailyReportActions';
import { getContractorPitLookupData, getRomLookupData } from 'Redux/actions/LookupActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  RoundedWrapper,
  FilterCol,
  FilterRow,
  StyledPicker
} from './styles';
import { withTheme } from 'styled-components';

const ic_eye = require('App/assets/images/ic_eye.png')

class ListDailyReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filters: {
        monthYear: {
          name: 'Month & Year',
          type: 'monthyearpicker',
          value: new Date()
        },
        isBlasted: {
          name: 'Status',
          value: '',
          lookup: [
            {
              value: '',
              label: 'All'
            },
            {
              value: 'true',
              label: 'Blasted'
            },
            {
              value: 'false',
              label: 'Unblasted'
            }
          ]
        },
        contractorId: {
          name: 'Contractor',
          type: 'multi',
          dispField: 'name',
          valField: 'id',
          value: [],
          lookup: []
        },
        pitId: {
          name: 'PIT',
          type: 'multi',
          dispField: 'name',
          valField: 'id',
          value: [],
          lookup: []
        },
        rom: {
          name: 'ROM',
          type: 'multi',
          dispField: 'romName',
          valField: 'id',
          value: [],
          lookup: []
        }
      },
      isShowModal: false,
      isConfirmed: false,
      isDeleted: false,
      deleteRow: {},
      reportList: [],
      checkedReport: [],
    }
  }

  componentDidMount() {
    this.props.toggleIsLoading(true)
    this.props.getContractorPitLookupData()
    this.props.getRomLookupData()
    this.getSavedFilters()
  }

  componentDidUpdate(prevProps) {
    const {
      contractorPitLookups, romLookups, dailyReportList, company,
      viewState: { isLoading }
    } = this.props
    const { filters, isShowModal, isConfirmed, deleteRow } = this.state

    if (prevProps.contractorPitLookups !== contractorPitLookups && isLoading) {
      const obj = Object.assign(filters)

      filters['contractorId'].lookup = contractorPitLookups
      filters['isBlasted'].value = filters['isBlasted'].lookup[0].value

      this.setState({ filters: obj }, () => {
        this.props.toggleIsLoading(false)
      })
    }

    if (prevProps.romLookups !== romLookups) {
      const obj = Object.assign(filters)
      if (romLookups.data) filters['rom'].lookup = romLookups.data.find(r => r.companyCode === company.code).children
      this.setState({ filters: obj })
    }

    if (prevProps.dailyReportList !== dailyReportList) {
      this.setState({ reportList: dailyReportList })
    }

    if (isConfirmed && isShowModal) {
      this.deleteReport(deleteRow)
    }
  }

  buildParams() {
    const filterObj = Object.entries(this.state.filters)
    let params = [];
    for (const [key, filter] of filterObj) {
      switch (filter.type) {
        case 'monthyearpicker':
          params.push(`${key}=${moment(filter.value).format('YYYY-MM-DD')}`)
          break;
        case 'multi':
          if (filter.value.length !== 0) {
            let multi = [];
            for (let v of filter.value) {
              multi.push(`${key}[]=${filter.name === 'ROM' ? v.romName : v.id}`)
            }
            params.push(multi.join('&'))
          } else params.push(`${key}=${filter.value}`)
          break;
        default: params.push(`${key}=${filter.value}`)
      }
    }
    return params.join('&')
  }

  refreshTable() {
    const params = this.buildParams()
    this.props.getAllDailyReports(params)
    this.setState({ checkedReport: [] })
  }

  getSavedFilters() {
    if (window.sessionStorage.getItem("filters") !== null) {
      let filtersObj = JSON.parse(window.sessionStorage.getItem("filters"))
      filtersObj.monthYear.value = new Date(filtersObj.monthYear.value)
      this.setState({ filters: filtersObj }, () => {
        this.refreshTable()
      })
    } else this.refreshTable()
  }

  onFilterChange(val, key) {
    const filterObj = Object.assign(this.state.filters)
    filterObj[key].value = val
    this.setState({ filters: filterObj }, () => {
      if (key === 'contractorId') {
        let pitsLookup = [];
        for (let value of val) {
          pitsLookup.push(...value.pits)
        }
        filterObj['pitId'].lookup = pitsLookup
        this.setState({ filters: filterObj })
      }
    })
  }

  renderFilterRow() {
    const inputConfig = {
      border: this.props.theme.mocaGrey,
      rad: '6px',
      width: 'auto',
      yxPadding: '9px 12px',
      height: '34px',
      arrowSize: '16px',
      arrowPos: 'calc(100% - 12px)'
    }
    const { filters } = this.state

    const CustomInput = ({ value, onClick }) => (
      <StyledPicker
        onClick={onClick}
        value={value}
        {...inputConfig}
      />
    );

    return (
      <FilterRow>
        {
          Object.entries(filters).map(([key, value]) => (
            <FilterCol key={key}>
              <Label lineheight={'14px'} size={'12px'}>
                {value.name}
              </Label>
              {
                value.type === 'multi' ? (
                  <FormMultiSelect
                    placeholder={`Select ${value.name}`}
                    options={value.lookup}
                    value={value.value}
                    dispField={value.dispField}
                    valField={value.valField}
                    onChangeVal={e => this.onFilterChange(e, key)}
                  />
                ) : value.type === 'monthyearpicker' ? (
                  <DatePicker
                    dateFormat="MMMM - yyyy"
                    selected={value.value}
                    onChange={date => this.onFilterChange(date, key)}
                    showMonthYearPicker
                    customInput={<CustomInput />}
                  />
                ) : (
                  <FormSelect
                    placeholder={`Select ${value.name}`}
                    onChangeVal={e => this.onFilterChange(e.target.value, key)}
                    options={value.lookup}
                    valField={'value'}
                    dispField={'label'}
                    {...inputConfig}
                  />
                )
              }
            </FilterCol>
          )
          )
        }
        <ButtonReg
          btnTxt={
            <IconPng srcIcon={ic_eye} ml={'0'} mb={'3px'} size={'auto'} h={'13'} showPointer={true} />
          }
          rad={'6px'}
          disabled={false}
          width={'34px'}
          height={'34px'}
          onClick={this.refreshTable.bind(this)}
        />
      </FilterRow>
    )
  }

  toggleChecklist(row, field) {
    const { reportList, checkedReport } = this.state
    const isChecked = row.hasOwnProperty(field) ? !row[field] : true
    const newList = reportList.map(r => r.id === row.id ? { ...r, [field]: isChecked } : r)
    this.setState({
      reportList: newList,
      checkedReport: lo.xorBy(checkedReport, [row], 'id')
    }, () => {
      if (checkedReport.length <= 1) this.disableChecklist()
    })
  }

  disableChecklist() {
    const { reportList, checkedReport } = this.state
    let rowDate = ''
    if (checkedReport.length !== 0) {
      const checkedRow = reportList.find(r => r.id === checkedReport[0].id)
      rowDate = moment(new Date(checkedRow.date)).format('DD - MMM - YYYY')
    }

    const newList = reportList.map(r => {
      const rDate = moment(new Date(r.date)).format('DD - MMM - YYYY')
      const isAllowedEdit = rDate === rowDate || rowDate.length === 0 ? true : false
      return { ...r, 'isAllowedEdit': isAllowedEdit }
    })
    this.setState({ reportList: newList })
  }

  switchModal() {
    const { isShowModal } = this.state
    this.setState({ isShowModal: !isShowModal })
  }

  switchIsConfirmed() {
    const { isConfirmed } = this.state
    this.setState({ isConfirmed: !isConfirmed })
  }

  switchIsDeleted() {
    const { isDeleted } = this.state
    this.setState({ isDeleted: !isDeleted })
  }

  onDeleteReport(row) {
    this.switchModal()
    this.setState({ deleteRow: row })
  }

  async deleteReport(row) {
    const { isDeleted, isConfirmed } = this.state
    const params = `${row['id']}?reportType=${row['reportType']}`
    try {
      const res = await deleteData(`${DAILY_REPORT}/${params}`)
      if (res.status === 204) {
        if (!isDeleted && isConfirmed) {
          this.switchIsDeleted()
          this.switchIsConfirmed()
          this.refreshTable()
        }
      } else {
        throw res.message
      }
    } catch (error) {
      alert(error)
    }
  }

  onCloseModal() {
    const { isShowModal, isDeleted } = this.state
    if (isShowModal && isDeleted) {
      this.switchModal()
      this.switchIsDeleted()
    }
  }

  onSizePerPageChange = (size) => {
    const { setLocalSettingsTableData, settingsTable } = this.props
    const settings = lo.cloneDeep(settingsTable)
    settings.sizePerPage['Report'] = size
    setLocalSettingsTableData(settings)
  }

  buildDetailUri(row) {
    const { match: { url } } = this.props
    const params = `${row.reportType}=${row.id}`
    return `${url}/${params}`
  }

  buildPreviewUri() {
    const { match: { url } } = this.props
    const { checkedReport } = this.state
    const romInspections = lo.filter(checkedReport, (r) => {
      return r.reportType.includes('rom')
    }).map(r => r.id)
    const pitInspections = lo.filter(checkedReport, (r) => {
      return r.reportType.includes('pit')
    }).map(r => r.id)
    const params = `${romInspections.length !== 0 ? 'rom_inspection=' + romInspections.join(',') + '&' : ''}${pitInspections.length !== 0 ? 'daily_pit_inspection=' + pitInspections.join(',') : ''}`
    return `${url}/preview&${params}`
  }

  onOpenDetail(row) {
    const uri = this.buildDetailUri(row)
    window.sessionStorage.setItem("filters", JSON.stringify(this.state.filters))
    return uri
  }

  render() {
    const { theme, settingsTable, viewState: { isLoading } } = this.props
    const { isShowModal, isDeleted, checkedReport, reportList } = this.state

    const sizePerPage = settingsTable.sizePerPage['Report']

    const modalConfig = {
      width: '391px',
      height: '452px'
    }

    const tableConfig = [
      {
        headerStyle: { width: 10 },
        formatter: selectionFormatter,
        formatExtraData: {
          allowEdit: (row) => row.isAllowedEdit !== undefined ? row.isAllowedEdit : true,
          field: 'isChecked',
          fn: (row, field) => this.toggleChecklist(row, field)
        },
        headerAlign: 'center',
        align: 'center',
      },
      {
        dataField: 'date',
        headerStyle: { width: 100 },
        text: 'Date',
        sort: true,
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{moment(row[formatExtraData]).format('DD - MMM - YYYY')}</div>
        },
        formatExtraData: 'date'
      },
      {
        dataField: 'reportType',
        headerStyle: { width: 100 },
        text: 'Type',
        sort: true,
        formatter: (cell, row, rowIndex, formatExtraData) => {
          return <div>{row[formatExtraData].includes('pit') ? 'PIT Inspections' : 'ROM Inspections'}</div>
        },
        formatExtraData: 'reportType'
      },
      {
        dataField: 'contractorCode',
        headerStyle: { width: 100 },
        text: 'Contractor',
        sort: true
      },
      {
        dataField: 'pitName',
        headerStyle: { width: 100 },
        text: 'PIT',
        sort: true
      },
      {
        dataField: 'romName',
        headerStyle: { width: 100 },
        text: 'ROM',
        sort: true
      },
      {
        dataField: 'isBlasted',
        headerStyle: { width: 100 },
        text: 'Status',
        sort: true,
        formatter: statusBtnFormatter,
        formatExtraData: {
          field: 'isBlasted',
          type: 'Daily Report',
          auto: true,
          theme,
        }
      },
      {
        dataField: 'action',
        headerStyle: { width: 100 },
        text: 'Action',
        formatter: actionFormatter,
        formatExtraData: {
          allowEdit: false,
          allowDel: true,
          detailBtn: true,
          del: (row) => this.onDeleteReport.bind(this, row),
          detailUrl: (row) => this.onOpenDetail(row)
        },
      }
    ]

    return (
      <>
        <ModalPage
          isOpen={isShowModal}
          onBackgroundClick={this.switchModal.bind(this)}
          contentChild={
            <ConfirmModal
              isSuccess={isDeleted}
              fnClose={this.switchModal.bind(this)}
              fnConfirm={this.switchIsConfirmed.bind(this)}
              fnBack={this.onCloseModal.bind(this)}
              txtConfirm={TxtConfirmDeleteDailyReport}
              txtSuccess={TxtSuccessDeleteDailyReport}
            />
          }
          {...modalConfig}
        />
        {!isLoading &&
          <RoundedWrapper>
            {this.renderFilterRow()}
            <DataTables
              leftSlot={
                <>
                  <Link to={this.buildPreviewUri()} style={{ textDecoration: 'none' }}>
                    <ButtonReg
                      btnTxt={'Preview Report'}
                      disabled={checkedReport.length ? false : true}
                      width={'127px'}
                      height={'40px'}
                      margin={'0 28px 0 0'}
                    />
                  </Link>
                  <Label size={'12px'} mb={'0px'} color={'#00B4A5'}>
                    {checkedReport.length ? `Selected ${checkedReport.length} report` : ''}
                  </Label>
                </>
              }
              dataList={reportList ? reportList : []}
              columnConfig={tableConfig}
              wrapperClasses="table-responsive"
              sizePerPage={sizePerPage}
              onSizePerPageChange={this.onSizePerPageChange}
            />
          </RoundedWrapper>
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    viewState: state.viewState,
    contractorPitLookups: state.contractorPitLookups,
    romLookups: state.romLookups,
    dailyReportList: state.dailyReportList,
    company: state.globals.company,
    settingsTable: state.settingsTable
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getContractorPitLookupData,
      getRomLookupData,
      getAllDailyReports,
      setLocalSettingsTableData
    },
    dispatch
  )

export default withRouter(
  withTheme(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(ListDailyReport)
  )
);
